import { Layout } from '@/shared/wrappers/Layout'
import { Button } from '@/ui/button'
import { ArrowsCounterIcon } from '@/ui/icons/arrows-counter-icon'
import { BigMeshIcon } from '@/ui/icons/big-mesh-icon'
import { StarfieldBackground } from '@/ui/starfield-background'
import { useTranslation } from 'react-i18next'

interface OfflineScreenProps {
  retry: () => void
}

export const OfflineScreen = ({ retry }: OfflineScreenProps) => {
  const { t } = useTranslation('app')
  return (
    <Layout
      className="fixed inset-0 flex flex-col gap-6 items-center justify-center  z-9999"
      safeX="safe"
      safeY="safe"
      width={'full'}
      height={'full-height'}
    >
      <StarfieldBackground amount={300} speed={8} scrollBoost={4} />
      <div className="flex flex-col items-center text-center justify-center gap-2">
        <div className="pb-[40px]">
          <BigMeshIcon />
        </div>

        <h1 className="text-x28 font-bold leading-[39px]">
          {t('offline_screen.title')}
        </h1>
        <p className=" text-x18 text-gray-400 max-w-[80%] leading-[25px]">
          {t('offline_screen.subtitle')}
        </p>
      </div>
      <Button variant={'tertiary'} size={'md'} className="px-8" onClick={retry}>
        <ArrowsCounterIcon />
      </Button>
    </Layout>
  )
}
